import React from 'react';
import SourceBadge from './SourceBadge';
import { Button, Box, Tooltip } from '@mui/material';
import { Lock } from '@mui/icons-material';

const ZillowEstimateCell = ({ listing, propertyData, listingId, isProUser, onSubscriptionModal }) => {
  const renderEstimate = () => {
    if (!propertyData) {
      return (
        <div className="flex items-center space-x-2">
          <div className="animate-pulse flex space-x-2 items-center">
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>
      );
    }

    const { status } = propertyData;

    switch (status) {
      case 'queued':
        return (
          <div className="flex items-center space-x-2">
            <svg className="animate-spin h-4 w-4 text-[#96ffa8]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-sm text-gray-500">
              Queued (#{propertyData.queuePosition}) - {Math.ceil(propertyData.estimatedWaitTime)}s wait
            </span>
          </div>
        );

      case 'loading':
        return (
          <div className="flex items-center space-x-2">
            <svg className="animate-spin h-4 w-4 text-[#96ffa8]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-sm text-gray-500">Fetching value...</span>
          </div>
        );

      case 'success':
      case 'no_data':
        return (
          <div className="flex items-center">
            <span>{listing.marketValueFormatted}</span>
            {listing.dataSource && <SourceBadge source={listing.dataSource} />}
          </div>
        );

      case 'error':
        return (
          <div className="flex items-center text-red-500">
            <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Error loading data</span>
          </div>
        );

      default:
        return (
          <div className="flex items-center space-x-2">
            <div className="animate-pulse flex space-x-2 items-center">
              <div className="h-4 w-24 bg-gray-200 rounded"></div>
            </div>
          </div>
        );
    }
  };

  const handleClick = (e) => {
    if (!isProUser && onSubscriptionModal) {
      e.stopPropagation();
      onSubscriptionModal();
    }
  };

  // For basic users, show only property name and basic Zillow estimate
  // All other columns should be blurred
  return (
    <div 
      className="flex items-center relative"
      style={{ cursor: !isProUser ? 'pointer' : 'default' }}
      onClick={handleClick}
    >
      <span className="text-black font-medium">
        {listing.marketValueFormatted || renderEstimate()}
      </span>
      {listing.dataSource && <SourceBadge source={listing.dataSource} />}
    </div>
  );
};

export default ZillowEstimateCell;